import { TranslationKeys } from '../types';
import { es } from './es/index';

const esTranslations: TranslationKeys = es;

export default esTranslations;
